<template>
  <div class="pt-20">
    <SubHeader
      title="مشـــاريعنا"
      description="فريقنا يضم موظفي إنتاج وفحص ذوي خبرة يضمنون تحقيق أعلى معايير الجودة."
    />
    <CategoryView />
  </div>
</template>
